import LandmarksAPI from '../api/landmarksid';
import {all, call, takeLatest, put} from 'redux-saga/effects'

import {getBoundsOrCenterFromGeo} from '../shared/helpers/geojson';

import createHistory from 'history/createHashHistory'

import {
    SAGA_LOAD_POI,
    SAGA_CREATE_FENCE,
    RESET_POI,
    SAGA_GET_POI_DUPLICATES,
    SAGA_REMOVE_DUPLICATE_POI,
    SAGA_UPDATE_POI_FENCE,
    SAGA_PATCH_POI,
}from './actions';

import {
    setPOI,
    serverLoadPOI,
    setPOIDuplicates,
} from './actions';

import {
    setCenter,
} from '../shared/actions';

// import {setError, resetErrors} from '../errors/actions';

const history = createHistory();

// Get POI from the server
function* getPoi(action) {
  const results = yield call(LandmarksAPI.getPoi, action.payload.poiId);

  // Error checking the server response
  if (results.error === null && results.json !== null){
      yield put(setPOI(results.json.body));
      yield put(setCenter(getBoundsOrCenterFromGeo(results.json.body.poi.location)))
  }else {
      yield put({type: 'ERROR_IN_FETCHING_DATA'});
  }
}

// Get POI Duplicates from the server
function* getPOIDuplicates(action) {
    const results = yield call(LandmarksAPI.getPOIDuplicates, action.payload.poiId);
  
    // Error checking the server response
    if (results.error === null && results.json !== null){
        if (results.json.body.length === 0) {
            history.push(`/validation/poiOrganization/${action.payload.poiId}`);
        }
        yield put(setPOIDuplicates(action.payload.poiId, results.json.body));
    }else {
        yield put({type: 'ERROR_IN_FETCHING_DATA'});
    }
  }

function* createPoiFence(action) {
    const results = yield call(LandmarksAPI.createPoiFence, action.payload.poiId, action.payload.fence, action.payload.accuracy);
    // Error checking the server response
    if (results.error === null){
        yield put({type: RESET_POI, payload: { poiId: action.payload.poiId }});
        yield put(serverLoadPOI(action.payload.poiId));
    }else {
        yield put({type: 'ERROR_IN_FETCHING_DATA'});
    }
}

function* removeDuplicatePoi(action) {
    const results = yield call(LandmarksAPI.removePOI, action.payload.poiId);
    if (results.error === null){
        yield put({type: RESET_POI, payload: { poiId: action.payload.poiId }});
        yield put(serverLoadPOI(action.payload.poiId));
    }
}

function* updatePOIFence(action) {
    const results = yield call(LandmarksAPI.putFence, action.payload.fenceId, action.payload.geo, action.payload.accuracy);
    if (results.error === null && results.json) {
        yield put({type: RESET_POI, payload: { poiId: action.payload.poiId }});
        yield put(serverLoadPOI(action.payload.poiId));
    }
}

function* patchPOI(action){
    const results = yield call(LandmarksAPI.patchPOI, action.payload.poiId, action.payload.body);
    if (results.error === null && results.json) {
        yield put({type: RESET_POI, payload: { poiId: action.payload.poiId }});
        yield put(serverLoadPOI(action.payload.poiId));
    } else {
        yield put({type: 'ERROR_IN_FETCHING_DATA'});
    }
}

// Server functions

export default function* poisSaga(){
	yield all([
        takeLatest(SAGA_LOAD_POI, getPoi),
        takeLatest(SAGA_CREATE_FENCE, createPoiFence),
        takeLatest(SAGA_GET_POI_DUPLICATES, getPOIDuplicates),
        takeLatest(SAGA_REMOVE_DUPLICATE_POI, removeDuplicatePoi),
        takeLatest(SAGA_UPDATE_POI_FENCE, updatePOIFence),
        takeLatest(SAGA_PATCH_POI, patchPOI),
	]);
}


// WEBPACK FOOTER //
// ./src/pois/sagas.js